package com.checkin.host.ui.auth

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

sealed class AuthRoute {
    data object Login : AuthRoute()
    data object Register : AuthRoute()
    data object ForgotPassword : AuthRoute()
    data class VerifyPending(val email: String) : AuthRoute()
    data class VerifyEmail(val token: String) : AuthRoute()
    data class ResetPassword(val token: String) : AuthRoute()
    data class LegalPrivacy(val returnRoute: AuthRoute) : AuthRoute()
    data class LegalTerms(val returnRoute: AuthRoute) : AuthRoute()
    data class LegalDpa(val returnRoute: AuthRoute) : AuthRoute()
}

fun authRouteFromWindow(): AuthRoute? =
    authRouteFromQueryString(window.location.search)
        ?: authRouteFromQueryString(hashToQueryString(window.location.hash))

private fun hashToQueryString(hash: String): String {
    val trimmed = hash.removePrefix("#").trim()
    if (trimmed.isEmpty()) return ""
    if (trimmed.startsWith("?")) return trimmed
    if (trimmed.startsWith("/")) {
        val rest = trimmed.drop(1)
        return when {
            rest.startsWith("?") -> rest
            rest.contains("=") -> "?$rest"
            else -> ""
        }
    }
    return if (trimmed.contains("=")) "?$trimmed" else ""
}

private fun authRouteFromQueryString(query: String): AuthRoute? {
    if (query.isBlank()) return null
    val params = URLSearchParams(query)
    params.get("verify-email")?.takeIf { it.isNotBlank() }?.let { return AuthRoute.VerifyEmail(it) }
    params.get("reset-password")?.takeIf { it.isNotBlank() }?.let { return AuthRoute.ResetPassword(it) }
    return null
}

fun clearAuthQueryParams() {
    window.history.replaceState(null, "", window.location.pathname)
}

/** Lien email (reset MDP, vérif compte) — prioritaire même si une session est encore en cache. */
fun AuthRoute.isEmailDeepLink(): Boolean = when (this) {
    is AuthRoute.ResetPassword, is AuthRoute.VerifyEmail -> true
    else -> false
}
